import styled from 'styled-components'

export const SectionHeader = styled.div(({ theme }) => ({
  alignItems: 'flex-start',
  display: 'flex',
  gap: theme.space['12'],
}))

export const Content = styled.div({
  display: 'flex',
  flexDirection: 'column',
})

export const IconContainer = styled.div(({ theme }) => ({
  alignItems: 'center',
  background: 'transparent',
  border: `${theme.border.size['1']} solid ${theme.colors.gray500}`,
  borderRadius: theme.border.radius['16'],
  color: theme.colors.black800,
  display: 'flex',
  height: '5.4rem',
  justifyContent: 'center',
  width: '5.4rem',
}))

export const Title = styled.h1(({ theme }) => ({
  color: theme.colors.black800,
  fontSize: '2.2rem',
  fontWeight: 600,
  margin: 0,
}))

export const Description = styled.p(({ theme }) => ({
  color: theme.colors.black500,
  fontSize: '1.4rem',
  fontWeight: 500,
  margin: 0,
}))
